import { FlatList } from 'react-native';
import styled from 'styled-components/native';

import Row from '@src/components/Row';
import Separator from '@src/components/Separator';
import {
  idKeyExtractor,
  maxWidth,
  padding,
} from '@src/configuration/constants';
import { Post } from '@src/types';

export const List = styled(FlatList as new () => FlatList<Post>).attrs(() => ({
  removeClippedSubviews: true,
  scrollEventThrottle: 8,
  initialNumToRender: 1,
  maxToRenderPerBatch: 1,
  keyExtractor: idKeyExtractor,
  ItemSeparatorComponent: Separator,
  contentContainerStyle: {
    paddingBottom: padding,
    maxWidth: maxWidth,
    marginHorizontal: 'auto',
  },
}))``;

export const SearchContainer = styled(Row)`
  height: 64px;
  padding-horizontal: ${padding / 2}px;
  margin-vertical: ${padding}px;
`;
